import React from 'react';
import { Field, useFormikContext, FormikValues } from 'formik';
import { useIntl } from 'react-intl';
import { CustomSelect } from '@/components/form';
import { types } from '../../core/_models';

const initialFilters = {
  status: 'SUCCEED'
};

type TypeStatusKeys = typeof types[number]; // Cela crée un type qui correspond à l'un des éléments de 'types'

const typeStatuses: { [key in TypeStatusKeys]: string[] } = {
  order: ['PENDING', 'SUCCEED', 'CANCELLED'],
  payment: ['PENDING', 'SUCCEED', 'FAILED'],
};

const getIntlTypeKey = (type: string): string => {
  switch (type) {
    case 'payment':
      return 'TRX'
    default:
      return type.toUpperCase()
  }
}

const FilterForm = () => {
  const intl = useIntl();
  const { values } = useFormikContext<FormikValues>(); // Ajout du type `any` pour résoudre l'erreur de type `unknown`

  // Vérification explicite que values.type est une clé valide dans typeStatuses
  const selectedType = values.type as TypeStatusKeys;

  const statusOptions =
    selectedType && typeStatuses[selectedType]
      ? typeStatuses[selectedType].map((status) => ({
          value: status,
          label: intl.formatMessage({ id: `P2C.OPERATION.${getIntlTypeKey(selectedType)}_STATUS_${status}` }),
        }))
      : [];

  return (
    <>
      <Field
        default="Select type"
        component={CustomSelect}
        label="Type"
        name="type"
        options={types.map((s: string) => {
          return {
            value: s,
            label: intl.formatMessage({ id: `P2C.OPERATION.TYPE_${s.toUpperCase()}` })
          };
        })}
      />

      {selectedType && statusOptions.length > 0 && (
        <Field
          default="Select status"
          component={CustomSelect}
          label="Status"
          name="status"
          options={statusOptions}
        />
      )}
    </>
  );
};

export { FilterForm, initialFilters };
